import axios from 'axios';

const api = axios.create({
  baseURL: '/fksBi', // Proxy do frontend redireciona /fksBi para o backend
});

export default api;
